
import type { EvolutionChartConfig, EvolutionChartData, Params } from '@empathyco/insights'
import type { ComputedRef, PropType } from 'vue'
import type { FeatureIdEnum } from '../../../enums'
import { EvolutionChartComponent } from '@empathyco/insights'
import { computed, defineComponent, getCurrentInstance, onMounted, ref, watch } from 'vue'
import { UiAlert, UiProgressCircular } from '../../../components/keen-ui'
import { useKpis } from '../../../composables'
import { useToolReportingDaily } from '../../../composables/use-tooling-report-daily'
import { KpiEnum } from '../../../enums'
import KpisLegend from '../../kpis-legend.component.vue'

export default defineComponent({
  name: 'DailyChart',
  components: {
    KpisLegend,
    UiAlert,
    UiProgressCircular,
  },
  props: {
    tool: {
      type: String as PropType<FeatureIdEnum>,
      required: true,
    },
    toolId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const baseClass = 'daily-chart'
    const {
      proxy: { $epb },
    } = getCurrentInstance()
    const { findKpiOptionById } = useKpis()

    const dailyChartRef = ref(null)

    const dailyChartComponent = new EvolutionChartComponent()

    const clicksKpi = [KpiEnum.CLICKS]
    const clickOption = findKpiOptionById(KpiEnum.CLICKS)
    const kpiLegendItems = clickOption ? [clickOption] : []
    const errorMessage = $epb.messages.insights.toolReporting.aside.dailyChart.errorMessage
    const { dailyInfo, hasErrors, loading } = useToolReportingDaily({
      tool: props.tool,
      toolId: props.toolId,
    })

    const chartData: ComputedRef<Params<EvolutionChartConfig, EvolutionChartData>> = computed(
      () => {
        const formatter = new Intl.DateTimeFormat($epb.locale, {
          month: 'short',
          day: '2-digit',
        })
        return {
          config: {
            filteredValues: [
              {
                id: KpiEnum.CLICKS,
              },
            ],
          },
          data: dailyInfo.value.map(dailyEntry => ({
            id: Math.random().toString(),
            labels: [`${formatter.format(dailyEntry.date)}`],
            values: {
              clicks: [dailyEntry.clickCount],
            },
          })),
        }
      },
    )

    onMounted(() => {
      dailyChartComponent.init(dailyChartRef.value as HTMLElement, chartData.value)
    })

    watch(
      () => chartData,
      () => {
        dailyChartComponent.update(chartData.value)
      },
      { deep: true },
    )

    return {
      baseClass,
      dailyChartRef,
      kpiLegendItems,
      errorMessage,
      hasErrors,
      clicksKpi,
      loading,
    }
  },
})
